import { useMapEvents } from 'react-leaflet';
import type { LeafletMouseEvent } from 'leaflet';

/**
 * Reporta um toque/clique no mapa com as coordenadas geográficas e o ponto na tela.
 * Toques em controles (`.leaflet-control`) e em marcadores (`.leaflet-marker-icon`,
 * que têm seu próprio `onClick`) são ignorados. Usado no mobile para o tap-tooltip.
 */
export default function MapTapHandler({
  onTap,
}: {
  onTap: (lat: number, lng: number, x: number, y: number) => void;
}) {
  useMapEvents({
    click: (e: LeafletMouseEvent) => {
      const target = e?.originalEvent?.target as HTMLElement | null;
      if (target?.closest?.('.leaflet-control')) return;
      if (target?.closest?.('.leaflet-marker-icon')) return;
      onTap(e.latlng.lat, e.latlng.lng, e.containerPoint.x, e.containerPoint.y);
    },
  });

  return null;
}
